import { localize } from "vee-validate";

import pt_BR from "vee-validate/dist/locale/pt_BR.json";
localize("pt_BR", pt_BR);